import { call, takeLatest, select, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { makeBookingManagerApi, IGetHotelDetailsResponse } from 'services/BookingManagerApi';
import {
  GET_HOTEL_DETAILS_REQUEST,
  getHotelDetailsSuccessAction,
  getHotelDetailsFailureAction,
} from './actions';
import { bookingUuidSelector } from '../../selectors';

export function* getHotelDetailsSaga() {
  try {
    const bookingManagerApi = makeBookingManagerApi();
    const bookingUuid = yield select(bookingUuidSelector);

    const result: AxiosResponse<IGetHotelDetailsResponse> = yield call(bookingManagerApi.getHotelDetails, bookingUuid);

    yield put(getHotelDetailsSuccessAction(result.data.hotelDetails));
  } catch (e) {
    yield put(getHotelDetailsFailureAction(e));
  }
}

export function* watchBookingManagerHotelDetails() {
  yield takeLatest([GET_HOTEL_DETAILS_REQUEST], getHotelDetailsSaga);
}
